
      import { createComponent } from '@lit/react'
      import { type EventName } from '@lit/react'
      import * as React from 'react'

      import Component from '../../components/command/command.component.js'
      import type { DdsChangeEvent } from '../../events/events'
import type { DdsOpenedEvent } from '../../events/events'
import type { DdsClosedEvent } from '../../events/events'
import type { DdsCloseEvent } from '../../events/events'
      export type { DdsChangeEvent } from '../../events/events'
export type { DdsOpenedEvent } from '../../events/events'
export type { DdsClosedEvent } from '../../events/events'
export type { DdsCloseEvent } from '../../events/events'

      const tagName = 'dap-ds-command'

      /**
 * `dap-ds-command`
 * @summary A command is a component that displays a list of commands.
 * @element dap-ds-command
 * @title - Command
 *
 * @event {{ value: string }} dds-change - Fired when the command value changes.
 *
 * @slot trigger - The trigger element for the command dropdown.
 * @slot - The command items.
 */
      const reactWrapper = createComponent({
        tagName,
        elementClass: Component,
        react: React,
        events: {
          onDdsChange: 'dds-change' as EventName<DdsChangeEvent>,
onDdsOpened: 'dds-opened' as EventName<DdsOpenedEvent>,
onDdsClosed: 'dds-closed' as EventName<DdsClosedEvent>,
onDdsClose: 'dds-close' as EventName<DdsCloseEvent>
        },
        displayName: "DapDSCommand"
      })

      export default reactWrapper
    